import window from './window';

export function setCookie(name, value) {
  window.document.cookie = `${name}=${value || ''}`;
}
export function getCookie(name) {
  return `; ${window.document.cookie}`
    .split(`; ${name}=`)
    .pop()
    .split(';')[0];
}
